const doc = [({"da":({"js":({"merfoto":({"routes":({"welcome":({"welcome":"Velkommen"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;